import React from 'react';
import { motion } from 'framer-motion';
import { CountUp } from './motion/CountUp';
import { resultStats } from '../data/results';
export function ResultsStrip() {
  return <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border-2 border-line bg-line shadow-card md:grid-cols-4" data-id="element-303" data-mp="hhoaccx1gtb6">
      {resultStats.map((stat, index) => <motion.div key={stat.id} initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.4
    }} transition={{
      duration: 0.6,
      delay: index * 0.08,
      ease: [0.16, 1, 0.3, 1]
    }} className="group relative flex flex-col items-center justify-center overflow-hidden bg-white px-4 py-7 text-center" data-id="element-304" data-mp="dft732vjs5ur" data-mpi={index}>
          <span aria-hidden="true" className="absolute inset-x-6 -top-10 h-16 rounded-full bg-brand-blue/10 opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" data-id="element-305" data-mp="3lw5xqc9af1fa" />
          <dd className="relative font-display text-[36px] font-extrabold leading-none text-brand-blue" data-id="element-306" data-mp="2n0ewabw5xw4w">
            <CountUp value={stat.value} data-id="element-307" data-mp="2rsoro7g1roek" />
          </dd>
          <dt className="relative mt-2 text-[13px] font-medium leading-snug text-muted" data-id="element-308" data-mp="2e0s7cpkmeisq">
            {stat.label}
          </dt>
        </motion.div>)}
    </dl>;
}